webpackJsonp([114276838955818,60335399758886],{

/***/ 107:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Caspia","subtitle":"Teaching Computing in Prisons"}}},"layoutContext":{}}

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(209);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(107);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 303:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _profilePic = __webpack_require__(507);
	
	var _profilePic2 = _interopRequireDefault(_profilePic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Import typefaces
	//import 'typeface-montserrat'
	//import 'typeface-merriweather'
	
	//import { rhythm } from '../utils/typography'
	
	var Bio = function (_React$Component) {
	  _inherits(Bio, _React$Component);
	
	  function Bio() {
	    _classCallCheck(this, Bio);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Bio.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      {
	        style: {
	          display: 'flex',
	          marginBottom: '2rem'
	        }
	      },
	      _react2.default.createElement('img', {
	        src: _profilePic2.default,
	        alt: 'R. Kent James',
	        style: {
	          marginRight: '10px',
	          marginBottom: 0,
	          width: '4rem',
	          height: '4rem'
	        }
	      }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'I (R. Kent James) currently focus on teaching web development in a Washington state prison,\xA0',
	        _react2.default.createElement(
	          'a',
	          { href: 'http://www.doc.wa.gov/corrections/incarceration/prisons/mcc.htm', alt: 'Monroe Correctional Complex (MCC)' },
	          'WSR'
	        ),
	        '. Much of this blog will focus on the challenges of that environment, particularly web development with no direct internet access.'
	      )
	    );
	  };
	
	  return Bio;
	}(_react2.default.Component);
	
	exports.default = Bio;
	module.exports = exports['default'];

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/profile-pic.621ae08b.jpg";

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(47);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Bio = __webpack_require__(208);
	
	var _Bio2 = _interopRequireDefault(_Bio);
	
	__webpack_require__(303);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template(props) {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Template.prototype.render = function render() {
	    //console.log('this.props: ' + JSON.stringify(this.props))
	    var _props = this.props,
	        location = _props.location,
	        children = _props.children;
	
	
	    var header = _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'nav',
	        { className: 'navbar navbar-expand-sm navbar-dark bg-primary',
	          style: { marginBottom: '1em', paddingTop: '0em', paddingBottom: '0em' } },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            className: 'navbar-brand',
	            to: '/'
	          },
	          'Caspia'
	        ),
	        _react2.default.createElement('img', { src: '/caspiantern210x64.png', alt: 'Caspian Tern', title: 'Caspian Tern, By Ed Dunens - Caspian Tern, CC BY 2.0, https://commons.wikimedia.org/w/index.php?curid=64582408' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'collapse navbar-collapse' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'navbar-nav ml-auto' },
	            _react2.default.createElement(
	              'li',
	              { className: 'navbar-nav' },
	              _react2.default.createElement(
	                'a',
	                { className: 'nav-link', href: '/blog' },
	                'Blog'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'navbar-nav' },
	              _react2.default.createElement(
	                'a',
	                { className: 'nav-link', href: '/resources' },
	                'Resources'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'navbar-nav' },
	              _react2.default.createElement(
	                'a',
	                { className: 'nav-link', href: '/about' },
	                'About Me'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'navbar-nav' },
	              _react2.default.createElement(
	                'a',
	                { className: 'nav-link', href: '/contacts' },
	                'Contacts'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'navbar-nav' },
	              _react2.default.createElement(
	                'a',
	                { className: 'nav-link', href: '/links' },
	                'Links'
	              )
	            )
	          )
	        )
	      )
	    );
	
	    var footer = _react2.default.createElement(
	      'div',
	      { style: {
	          fontStyle: 'italic',
	          marginBottom: '1rem'
	        } },
	      _react2.default.createElement('hr', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Caspia is my personal project dedicated to help prisoners in the state of Washington learn to code. I lead a technical seminar at ',
	        _react2.default.createElement(
	          'a',
	          { href: 'http://www.doc.wa.gov/corrections/incarceration/prisons/mcc.htm' },
	          'WSR '
	        ),
	        'in Monroe, Washington where a group of prisoners is learning web design using the nodejs platform.'
	      )
	    );
	    return _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      header,
	      children(),
	      footer
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	exports.default = Template;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-1cf156af39ed5176bb9a.js